export default __webpack_public_path__ + "static/media/logo.22cbc994.png";